import { useState, useContext, useEffect } from "react"
import { RatingStars } from "./RatingStars"
import { Link } from "react-router-dom"
import { UserContext } from "../../contexts/UserContext"
import { userReducer } from "../../contexts/UserContext"
import { handleUpdateArray } from "../../functions/UpdateUser"
import { ProductsContext } from "../../contexts/ProductsContext"
import "./product.css"

export function Product({ name, regularPrice, salePrice, discount, newProduct, id, image, rating, reviews, explore, wishlist }) {
    const productsDataContext = useContext(ProductsContext)
    const { products } = productsDataContext

    const userDataContext = useContext(UserContext)
    const { user } = userDataContext

    const [thisProduct, setThisProduct] = useState(null)
    const [productType, setProductType] = useState(null)
    const [addToCartShown, setAddToCartShown] = useState(false)
    const [inWishlist, setInWishlist] = useState(null)
    const [inCart, setInCart] = useState(null)

    useEffect(() => {
        if(products) {
            const findProduct = products.find(e => e._id === id)
            setThisProduct(findProduct)
        }
    }, [products])

    useEffect(() => {
        if(thisProduct) {
            if(thisProduct.colours || thisProduct.sizes) {
                setProductType("variant")
            } else {
                setProductType("normal")
            }
        }
    }, [thisProduct])
    
    useEffect(() => {
        if(user) {
            setInWishlist(user.wishlist.find(e => e._id === id))
            setInCart(user.cart.find(e => e._id === id))
        }
    }, [user])

    function updateWishlist(e) {
        e.preventDefault()
        // we have to update the local state after it is successfully updated on the server. we want to make the updateUser route simple therefore we make a "userDataClone" and update his wishlist so we can only send the updated wishlist in the body of the request.
        let userDataClone = { userData: { user } }

        if(inWishlist) {
            userDataClone = userReducer(userDataClone, { type: "REMOVE_FROM_WISHLIST", payload: id })
            const updatedWishlist = userDataClone.userData.user.wishlist
            handleUpdateArray(updatedWishlist, "REMOVE_FROM_WISHLIST", id, userDataContext)
        } else {
            userDataClone = userReducer(userDataClone, { type: "ADD_TO_WISHLIST", payload: thisProduct })
            const updatedWishlist = userDataClone.userData.user.wishlist
            handleUpdateArray(updatedWishlist, "ADD_TO_WISHLIST", thisProduct, userDataContext)
        }
    }

    function addToCart() {
        let userDataClone = { userData: { user } }

        const newCartItem = {
            ...thisProduct,
            customId: crypto.randomUUID(),
            quantity: 1,
            color: null,
            size: null,
            type: "normal"
        }

        userDataClone = userReducer(userDataClone, { type: "ADD_TO_CART", payload: newCartItem })
        const updatedCart = userDataClone.userData.user.cart
        handleUpdateArray(updatedCart, "ADD_TO_CART", newCartItem, userDataContext)
    }

    return (
        <div className="d-flex flex-column product-container">

            <Link to={`/shop/${id}`} target="" className="d-flex cntr position-relative product-section overflow-hidden rounded-1"
                onMouseEnter={() => setAddToCartShown(true)}
                onMouseLeave={() => setAddToCartShown(false)}>

                <div className="product-image" style={{ backgroundImage: "url('" + image +  "')"}}>  
                </div>

                <div className="position-absolute start-0 top-0 w-100 product-actions">
                    <div className="d-flex justify-content-between align-items-start">
                        <div
                            className={
                                "d-flex cntr text-white m-2 rounded-1 product-label " + (
                                    discount ?
                                        "discount-label"
                                        : (newProduct ? "new-label" : "")
                                )
                            }>
                            {
                                discount ?
                                    "-" + discount + "%"
                                : newProduct ?
                                    "NEW"
                                :
                                    null
                            }
                        </div>
                        <div className="d-flex flex-column gap-2 m-2 product-icons">
                            {
                                wishlist ?
                                    <div onClick={updateWishlist} className="delete-icon"></div>
                                    :
                                    <>
                                        <div
                                            onClick={updateWishlist}
                                            className={inWishlist ? "wishlist-heart" : "heart-icon"}>
                                        </div>
                                        {/* <div
                                            onClick={() => {
                                                window.open(`/shop/${id}`, "_blank")
                                            }}
                                            className="view-icon">
                                        </div> */}
                                    </>
                            }
                        </div>
                    </div>

                    {/* THIS DIV WAS LINK. IN CASE SOMETHING BROKE REVERSE */}
                    <div
                        onClick={(e) => {
                            e.stopPropagation()
                            if(productType === "normal" && !inCart) {
                                addToCart()
                                alert(productType, " ", inCart)
                            }
                        }}
                        /* to={productType === "variant" ? `/shop/${id}` : ""} */
                        /* target={productType === "normal" ? "" : "_blank"} */
                        className={`${inCart && "inCart"} ${addToCartShown ? "on" : ""} d-flex cntr position-absolute add-btn start-0 top-100 w-100 py-1 fw-normal  text-center text-white`}>
                            <div className="add-to-cart-icon me-2"></div>
                            {inCart ? "Update Cart" : "Add To Cart"}
                    </div>
                </div>

            </Link>

            <div className="d-flex flex-column product-details mt-2">

                <Link to={`/shop/${id}`} target="" className="text-black name">
                    {name}
                </Link>

                <div className={"d-flex " + (explore ? "" : "flex-column")}>
                    <div>
                        <span className="price-text me-2">
                            {"$" + (salePrice ? salePrice : regularPrice)}
                        </span>
                        <span
                        className={(salePrice ? "original-price " : "d-none") + (explore ? "d-none" : "")}>
                            {"$" + regularPrice}
                        </span>
                    </div>

                    <div className="d-flex align-items-center product-rating">
                        <RatingStars rating={rating} />
                        <div className="reviews">{"(" + reviews + ")"}</div>
                    </div>
                </div>

            </div>

        </div>
    )
}